import { render } from "./PricingPlans.vue?vue&type=template&id=1d556a85&scoped=true&ts=true"
import script from "./PricingPlans.vue?vue&type=script&lang=ts"
export * from "./PricingPlans.vue?vue&type=script&lang=ts"

import "./PricingPlans.vue?vue&type=style&index=0&id=1d556a85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d556a85"]])

export default __exports__